import { z } from 'zod'

export const OtnReasonSchema = z.object({
  reason_id: z.number(),
  caption: z.string(),
  type: z.string(),
  channel: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  is_re_optin_enabled: z.boolean(),
  request_title: z.string(),
  request_image: z.array(z.string()).or(z.record(z.string(), z.unknown())).nullable(),
})
